import { Capacitor, CapacitorHttp } from '@capacitor/core';

const mapboxToken = import.meta.env.VITE_REACT_APP_MAPBOX_TOKEN;

async function getJson(url: string, headers?: Record<string, string>): Promise<any> {
  if (Capacitor.isNativePlatform()) {
    const response = await CapacitorHttp.get({ url, headers });
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`HTTP ${response.status}`);
    }
    if (typeof response.data === 'string') {
      return JSON.parse(response.data);
    }
    return response.data;
  }

  const response = await fetch(url, { headers });
  if ('ok' in response && !response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.json();
}

function formatCoords(lat: number, lng: number): string {
  return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
}

export async function reverseGeocode(lat: number, lng: number): Promise<string | null> {
  if (mapboxToken) {
    try {
      const mapboxUrl =
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json` +
        `?access_token=${mapboxToken}&types=address,place,postcode,locality&limit=1`;
      const data = await getJson(mapboxUrl);
      const placeName = data?.features?.[0]?.place_name;
      if (placeName && typeof placeName === 'string') {
        return placeName;
      }
    } catch {
      // Fall through to Nominatim fallback.
    }
  }

  try {
    const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
    const data = await getJson(nominatimUrl, {
      'Accept-Language': 'en-GB,en;q=0.9',
      'User-Agent': 'ClubRoots/1.0',
    });
    const displayName = data?.display_name;
    if (displayName && typeof displayName === 'string') {
      return displayName;
    }
  } catch {
    // Fall through to null.
  }

  return null;
}

export { formatCoords };
